import GoogleMapsLoader from 'google-maps';
import markerImageGreen from '../../images/marker_green.svg';

let lastOpenedInfoWindow = null;

const closelastOpenedWindow = function () {
  if (lastOpenedInfoWindow) {
    lastOpenedInfoWindow.close();
  }
};

const loadMarkers = function (googleObj, map, data) {
  var bounds = new googleObj.maps.LatLngBounds();

  if (data) {
    data.forEach(function (post) {
      if (post.acf.google_maps) {
        var adress = post.acf.google_maps;
        var marker = null;
        var infowindowContent = '';

        marker = new googleObj.maps.Marker({
          position: new googleObj.maps.LatLng(
            parseFloat(adress.lat),
            parseFloat(adress.lng)
          ),
          map: map,
          icon: {
            url: markerImageGreen,
            scaledSize: new googleObj.maps.Size(30, 30),
          },
          marker_id: post.id,
          title: post.title.rendered,
        });

        bounds.extend(marker.position);

        infowindowContent = `<a class='infowindow d-block' href='/siedlungen/${post.slug}'>
            <span class='mb-0 d-block'>${post.title.rendered}</span>
            <span class='mb-0 d-block'>${post.acf.adresse.ort} →</span>
          </a>`;

        var infowindow = new googleObj.maps.InfoWindow({
          content: infowindowContent,
        });

        marker.addListener('click', function () {
          closelastOpenedWindow();
          infowindow.close();
          infowindow.open(map, marker);
          lastOpenedInfoWindow = infowindow;
        });

        googleObj.maps.event.addListener(map, 'click', function () {
          if (infowindow) {
            infowindow.close();
          }
        });
      }
    });

    map.fitBounds(bounds, { top: 300, left: 300, right: 300, bottom: 300 });

    var listener = googleObj.maps.event.addListener(map, 'idle', function () {
      map.setZoom(12);

      if (window.innerWidth < 768) {
        map.setZoom(11);
      }

      googleObj.maps.event.removeListener(listener);
    });
  }
};

const initMap = function (domNodeId, mapStyle, siedlungen) {
  console.log('init map');
  console.log(GoogleMapsLoader);
  GoogleMapsLoader.LANGUAGE = 'de';
  GoogleMapsLoader.REGION = 'CH';
  GoogleMapsLoader.KEY = 'AIzaSyDFxMh-Ow7mU7mDxUwGw-D0kSqXUkhWZKw';
  GoogleMapsLoader.VERSION = '3.34';
  GoogleMapsLoader.load(function (google) {
    let map = new google.maps.Map(document.getElementById(domNodeId), {
      center: { lat: 47.406431, lng: 8.58125 },
      zoom: 13,
      styles: mapStyle,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative',
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
    });

    loadMarkers(google, map, siedlungen);
  });
};

export default initMap;



// WEBPACK FOOTER //
// ./scripts/util/initMap.js